import { getLandingNotesCourseDetails } from '@/actions/notes';
import {
  capitalizeFirstLetter,
  capitalizeFirstLetterOnly,
} from '@/helpers/dataHelper';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Card, Skeleton } from 'antd';
import Link from 'next/link';
import router from 'next/router';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { Dispatch } from 'redux';

interface INoteSubjects {
  name: string;
  image: string;
  id: number;
  slug: string;
}

const NoteSubjectsLanding: FC<{ courseSlug: string }> = ({ courseSlug }) => {
  const dispatch: Dispatch = useDispatch();

  const { courseDetail, loading } = useSelector((state: RootStateOrAny) => ({
    courseDetail: state.notes?.landingNoteCourseDetail?.data,
    loading: state?.notes?.landingNoteCourseDetailLoading,
  }));

  const [name, setName] = useState<string>('');

  useEffect(() => {
    dispatch(getLandingNotesCourseDetails({ slug: courseSlug, data: '' }));
  }, []);

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target as HTMLInputElement;
    setName(value);
    dispatch(
      getLandingNotesCourseDetails({
        slug: courseSlug,
        data: { subject: (e.target as HTMLInputElement).value },
      })
    );
  };

  const showSearchBox = (
    <input
      value={name}
      className="input-hover-border border font-placeholder py-2 px-4 mb-5 w-100"
      onChange={(e) => onChange(e)}
      style={{
        borderRadius: '22px',
      }}
      placeholder="Search Subjects here . . ."
    />
  );

  return (
    <section className={`my-4`}>
      <div className="custom-container">
        <Button
          className=" mb-3"
          type="primary"
          onClick={() => {
            router.push('/notes');
          }}
        >
          <i className="fas fa-arrow-left"></i> &nbsp; Back
        </Button>

        <div className="row notes-sidebar justify-content-center pr-0">
          <h4 className="text-center">
            {capitalizeFirstLetterOnly(courseSlug)} Subjects
          </h4>
          {loading === 'request' ? (
            <Skeleton.Button
              active
              className="col-lg-7 col-md-6 col-sm-12 col-xs-12 w-100 text-center "
              shape="round"
              size="large"
              block
            ></Skeleton.Button>
          ) : (
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
              {showSearchBox}
            </div>
          )}
        </div>
        {loading === 'request' ? (
          <Row className="mt-4">
            {[...Array(1, 2, 3, 4)]?.map((i: number) => (
              <Col lg="3" md="6" key={i} className="mb-4">
                <div
                  className="course-item blog"
                  style={{
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px',
                    borderRadius: '16px',
                  }}
                >
                  <div
                    style={{
                      height: '200px',
                    }}
                  >
                    <Skeleton.Image
                      className="w-100 h-100"
                      style={{
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                      }}
                    />
                  </div>
                  <div className="course-content py-3">
                    <div className="content-detail text-center ">
                      <Skeleton.Input active />
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        ) : courseDetail?.subjects?.length !== 0 ? (
          <Row>
            {courseDetail?.subjects?.map((subject: INoteSubjects, i: number) => (
              <Col lg="3" md="6" key={i} className="mb-4">
                <Link href={`/notes/${courseSlug}/${subject.slug}/contents`}>
                  <a>
                    <Card
                      className={` mock-test-course`}
                      hoverable
                      style={{
                        borderRadius: '15px',
                      }}
                      cover={
                        <img
                          alt={subject?.name}
                          style={{
                            height: '150px',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                          }}
                          src={
                            subject.image
                              ? subject.image
                              : '/images/notesplaceholder.png'
                          }
                        />
                      }
                    >
                      <Card.Meta
                        className="d-flex align-items-center"
                        style={{
                          height: '45px',
                          fontStyle: 'Poppins,sans-serif',
                        }}
                        title={
                          <span className="text-wrap course-single-name d-flex">
                            {capitalizeFirstLetter(subject?.name)}
                          </span>
                        }
                      />

                      <div
                        className="go-to-course float-right position-absolute"
                        style={{ bottom: '3%', right: '6%' }}
                      >
                        <ArrowRightOutlined
                          rev=""
                          style={{ fontSize: '20px', color: '#1c599f' }}
                        />
                      </div>
                    </Card>
                  </a>
                </Link>
              </Col>
            ))}
          </Row>
        ) : (
          <span className="text-center">
            <p>
              <img
                src="/images/no_results.webp"
                height="250"
                width="250"
                className="mb-1"
              />
              <br />
              No subjects found.
              <br />
            </p>
          </span>
        )}
      </div>
    </section>
  );
};

export default NoteSubjectsLanding;
